
<template>
	<div ref='root'>
		<Container @scrollEvent='handleScroll' @search='searchTarget'>
			<div class="orderPage m-search">
				<div class='resultwrap'>
					<div class='options'>
						<div class='m-brand2'>
							<div class='content-left'>
								<Carousel v-model="noticeIndex" :autoplay-speed='5000' autoplay dots='none'>
									<CarouselItem v-for="item in noticeList" :key='item.id' v-if='item.big_image_url'>
										<div class="demo-carousel">
											<img v-real-img="item.big_image_url">
											<!-- <a class="detailImg" :tag='item.id' :style="{backgroundImage: 'url('+item.big_image_url+')'}"></a> -->
										</div>
									</CarouselItem>
								</Carousel>
								<div class="indicator">
									<div class="dots">
										<div class="dot" @mouseenter='noticeIndex=i - 1' :class='{active:i - 1==noticeIndex}' v-for='i in noticeList.length' :key="i"></div>
									</div>
								</div>
							</div>
							<div class='content'>
								<div class="info">
									<div class='logo-div'>
										<img class="logo" :key='getNoticeObj.head_image_url' :src="getNoticeObj.head_image_url" :onerror='errorImg'>
									</div>
									<div class="bname">
										<p class="title">{{getNoticeObj.type_desc}}</p>
										<p class="sub-title">2026-07-18 14:00:00</p>
										<!-- <p class="sub-title" v-if='getNoticeObj.valid_from'>{{formatNoticeDate(getNoticeObj.valid_from)}}</p> -->
									</div>
								</div>
								<div class='intro'>
									<h3 class="title">{{getNoticeObj.title}}</h3>
									<p class='detailshort f-ellip5' v-html="getNoticeObj.description"></p>
									<a @click='select("/order/notice")'>查看更多(More)<span>&gt;&gt;</span></a>
								</div>
							</div>
						</div>
						<!-- 搜索 -->
						<div class='resultinfo'>
							<label class="detail-search">
								<Input icon="ios-search" placeholder="搜索(Search)" v-model="searchValue" style='width:200px' @on-click='searchTarget()' @keyup.enter.native='searchTarget()'></Input>
							</label>
							<span class='gnum'> 商品共<i>{{productCount}}</i> 個<b class='no_mobile'>(Products Summary :<i>{{productCount}}</i>)</b></span>
						</div>
						<!-- 篩選 -->
						<!-- <div class='opertaion'>
							<div class='m-classify z-cat3 j-box clearfix'>
								<div class="name"><i class="icon-tridown">►</i>&nbsp;分類(Type)</div>
								<div class="hdbrands">
									<div class="hdbrands2 ctag" :class='{auto:auto}'>
										<div class="brands all ctag">
											<a style='padding-right: 30px;' :class="{activity_menu: -1 == menuIndex}" @click="chooseMenu(-1)">全部(All)</a>
											<a v-for='(item,index) in (searchList||menuList)' :class="{activity_menu: index == menuIndex}" @click="chooseMenu(index)">
												{{item.name}} ({{item.name_en}})
											</a>
										</div>
									</div>
								</div>
								<div class='morewrap'>
									<div v-if='(searchList||menuList).length >= 6' class='more' @click='auto=!auto'>
										{{auto?'收起(Collapse)':'展開(Expand)'}}
										<span></span>
									</div>
								</div>
							</div>
						</div> -->
						<!-- 篩選 -->
						<!-- <div class='opertaion opertaion1'>
							<div class='m-filter'>
								<div class='hdorder'>
									<dl class='order'>
										<dd :class='{active:show_onlyHot}'><span @click='productFilter("hot")'>熱銷<b>(Hot)</b></span></dd>
										<dd :class='{active:show_onlyNew}'><span @click='productFilter("new")'>新品<b>(New)</b></span></dd>
										<dd :class='{active:show_onlyPromotion}'><span @click='productFilter("promotion")'>促銷<b>(Promotion)</b></span></dd>
										<dd :class='{active:price_sort}' class="padding">
											<span class="price_sort_span" style="display: inline-block;" @click='productFilter("sort")'>
												價格
												<b>(Price)</b>
												<div class='price_sort'>
													<Icon :class='{sort_active:price_sort == "asc"}' class='sort-icon asc' type="md-arrow-dropup"></Icon>
													<Icon :class='{sort_active:price_sort == "desc"}' class='sort-icon desc' type="md-arrow-dropdown"></Icon>
												</div>
											</span>
										</dd>
										<dd  :class='{active:pv_sort}' class="padding">
											<span class="pv_sort_span" style="display: inline-block;" @click='productFilter("pvsort")'>
												點數
												<b>(PV)</b>
												<div class='price_sort'>
													<Icon :class='{sort_active:pv_sort == "asc"}' class='sort-icon asc' type="md-arrow-dropup"></Icon>
													<Icon :class='{sort_active:pv_sort == "desc"}' class='sort-icon desc' type="md-arrow-dropdown"></Icon>
												</div>
											</span>
										</dd>
										<dd  :class='{active:sales_sort}' class="padding">
											<span class="pv_sort_span" style="display: inline-block;" @click='productFilter("sales")'>
												銷量
												<b>(Sales)</b>
												<div class='price_sort'>
													<Icon :class='{sort_active:sales_sort == "asc"}' class='sort-icon asc' type="md-arrow-dropup"></Icon>
													<Icon :class='{sort_active:sales_sort == "desc"}' class='sort-icon desc' type="md-arrow-dropdown"></Icon>
												</div>
											</span>
										</dd>
									</dl>
								</div>
									<div class="product-filter">
										<div class='m-priceBox'>
										<div class='priceInputs'>
											<label>
												<input placeholder="HK$" type="tel" v-model.number='t_priceBegin' />
											</label> -
											<label>
												<input placeholder="HK$" type="tel" v-model.number='t_priceEnd' />
											</label>
											<a class='clearbtn' @click='clearPriceFilter'>清空</a>
											<button class="btnconfirm" @click='filterPrice'>確定</button>
										</div>
									</div>
									<div class='m-addrbox'>
										<span class="tit">運送方式<em class="no_mobile">(Shipping Method)</em>:</span>
										<div class='addrselect'>
											<Button size='small'>
												{{default_store.Name}}
												{{default_store_id=='501'?'Package Deliver':'Pick up Station'}}
											</Button>
										</div>
									</div>
									<div class='m-checkbox'>
										<Checkbox v-model='show_onlystock'>僅看有貨(In stock)</Checkbox>
									</div>
									<div class='simplePage' v-if='false'>
										<span class="num"><i>1</i>/1</span>
										<span class="arrow-left def-left"></span>
										<span class='arrow-right def-right'></span>
									</div>
									</div>
							</div>
						</div> -->
						<!-- 産品列錶 -->
						<div class='m-result'>
							<ul>
								<template v-for='product in pageProducts'>
									<ProductCell :product='product' :key="product.sku" placement='bottom-end' @showSurveyfun='showSurveyfun' @showPromoCode='showPromoCode' @confrimfirst='confrimfirst' :firstOrder='isFirstOrder' :goodsWidth='goodsWidth' />
								</template>
							</ul>
						</div>
						<div class='pageRegion' v-if="PageIndex != 1">
							<Page className='customize' :total="productCount" :page-size='12' :current='PageIndex' @on-change='pageChange' />
						</div>
					</div>
				</div>
			</div>
		</Container>
		<transition mode="out-in">
			<router-view></router-view>
		</transition>
		<PromoCode :products='PromoModel' :show='PromoModelShow' @showPromoCode='showPromoCode'></PromoCode>
		<Warehouse :show='warehouseOpen' :storeId='default_store_id' @confirm='selectStore' @cancel='warehouseOpen=false' />
		<Modal v-model="lrpShow" width="700" title="提示" :mask-closable="false" :closable='false'>
			<div class='lrp' v-html='lrpContent'></div>

			<div slot="footer">
				<div class='lrpCancel'>
					<div class='lrpConfirm' v-if='lrpStatus'>
						確認要取消嗎?
					</div>
					<Button size="large" @click="lrpCancel">取消(cancel)</Button>
				</div>

				<Button type="primary" size="large" @click="lrpConfirm">創建(Create)</Button>
			</div>
		</Modal>
		<newCustomer :value='newValue' :isCart='true' @close='close' />
		<orderSurvey :model="survey" :value='showSurvey' @showSurveyfun='showSurveyfun' />
	</div>
</template>

<script>
import util from "@/config/util";
import ProductCell from "@/components/order/ProductCell";
import Warehouse from "@/components/order/warehouse";
import PromoCode from "@/components/order/PromoCode";
import newCustomer from "@/components/order/NewCustomer";
import orderSurvey from "@/components/order/orderSurvey";
import {
	cartInfoMethods,
	userInfoOrderMethods,
	systemConfigMethods,
	promoteMethods,
	productLimtMethods,
	promoCodeMethods
} from "@/components/common/mixin";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { cvoUrl } from "@/config/env";
export default {
	data() {
		return {
			noticeIndex: 0,
			errorImg: 'this.style.display="none"',
			searchValue: "",
			show_onlystock: false,
			show_onlyNew: false,
			show_onlyPromotion: false,
			show_onlyHot: false,
			price_sort: null,
			pv_sort: null,
			sales_sort:null,
			t_priceBegin: null,
			t_priceEnd: null,
			priceBegin: null, //價格顯示區間
			priceEnd: null,
			warehouseOpen: false,
			searchList: null,
			menuIndex: -1, //已選菜單索引值，默認為0
			menuIndexChange: true, //解決選中index時，scroll監聽事件重複判斷設置index的bug
			PageIndex: 1,
			pageCount: 12,
			scrollTop: 0,
			menuType: null,
			auto: true,

			//當前選中大會code
			PromoModel: null,
			PromoModelShow: false,

			lrpShow: false,
			lrpContent: null,
			lrpStatus: false,

			showNewCustomer: false,
			topMenus: [],
			notices: [],
			newValue: false,
			lrpName: { LRPT2: "LRP Kit2", LRPT1: "LRP Kit1" },
			cartProduct: { totalPrice: 0, totalPv: 0, load: true, list: [] }, //購物車商品列錶
			showSurvey: false,
			survey: null,
			
			

		};
	},
	created() {
		this.$nextTick(function() {
			this.menuType = !this.isEmpty(this.$route.query.type) && decodeURI(this.$route.query.type);
			this.switchLrp();
		});
	},
	destroyed() {
		//  window.removeEventListener('scroll', this.handleScroll);
	},
	mounted() {
	},
	watch: {
		shopCart: function(value) {
			//this.initCategoryNum();
		},
		$route(to, from) {
			if (to.path != "/order/product") {
			} else {
				var type =
					!this.isEmpty(to.query.type) && decodeURI(to.query.type);
				if (this.menuType != type) {
					this.menuType = type;
					this.selectType();
				}
			}
		}
	},
	mixins: [
		systemConfigMethods,
		userInfoOrderMethods,
		cartInfoMethods,
		promoteMethods,
		productLimtMethods,
		promoCodeMethods
	],
	components: {
		ProductCell,
		Warehouse,
		PromoCode,
		newCustomer,
		orderSurvey
	},
	computed: {
		...mapGetters([
			"getUserId",
			"getVipNo",
			"bogo_switch_tip",
			"getAccessToken"
		]),
		...mapState({
			warehouseInfo: state => state.order.warehouseInfo,
			sysConfig: state => state.common.sysConfig,
			productInfo: state => state.order.productInfo,
			productStockInfo: state => state.order.productStockInfo,
			userInfo: state => state.common.wechatUserInfo,
			guestInfo: state => state.common.guestInfo,
			forCustomer: state => state.order.forCustomer,
			cartInfo: state => state.order.cartInfo,
			isBuy: state => state.lrporder.isBuy,
			promote: state => state.order.promote,
			productLimt: state => state.order.productLimt,
			choosedAddress: state => state.order.choosedAddress,
			orderType: state => state.order.orderType,
			newpromoCode: state => state.order.newpromoCode
		}),
		goodsWidth(){
			if (document.body.clientWidth <= 768) {
				return 48
			}
			if (document.body.clientWidth > 768 && document.body.clientWidth < 1280) {
				return 30
			}
			return 22
		},
		userlevel() {
			return this.userInfo?.value?.binding?.customer_type || "Guest";
		},
		nowDate: function() {
			let Config = this.systemDetail;
			if (Config?.now_time) {
				return util.formatDate.dateFromStr(Config.now_time);
			}
			return util.realNowTime();
		},
		productStock: function() {
			let ret = [...((this.productStockInfo || {}).value || [])];
			return ret;
		},
		noticeList: function() {
			var item = this.notices || [];
			var message = item.filter(u => u.type.toLowerCase() != "message");
			var all = item.filter(u => u.type.toLowerCase() == "message");
			return [...message, ...all];
		},
		getNoticeObj() {
			let index = this.noticeIndex;
			if (this.noticeList[index]) {
				return this.noticeList[index];
			} else {
				return {};
			}
		},
		warehouseList: function() {
			return [...((this.warehouseInfo || {}).value || [])];
		},
		menuList: function() {
			var FirstOrder = this.isFirstOrder;
			let catalog = this.newcustomer;
			let isBuy = this.isBuy;
			let topMenus = this.topMenus;
			if (this.productInfo != null && this.productInfo.value != null) {
				var baseProductInfo = {
					value: []
				};
				var notsku = {};
				var newProductInfo = [];
				var copyProducts;
				var notHot;
				if (topMenus[0]) {
					this.productInfo.value.forEach((item, index) => {
						var obj = topMenus.filter(u => u.Code == item.code);
						if (obj[0]) {
							if (this.checkPermission(obj[0].RoleCode)) {
								item.RoleCode = obj[0].RoleCode;
								baseProductInfo.value.push(item);
							} else {
								item.products.forEach((item, index) => {
									if (!notsku[item.sku]) {
										notsku[item.sku] = 1;
									}
								});
							}
						}
					});
				} else {
					baseProductInfo.value = this.productInfo.value;
				}
				copyProducts = JSON.parse(JSON.stringify(baseProductInfo));

				copyProducts.value.forEach((item, i1, lists) => {
					var result = false;
					item.id = item.id || item.id == "" ? "0" : item.id;
					item.products.forEach((product, i2, productList) => {
						let sku = product.sku;
						let code = item.code && item.code.toLowerCase();
						if (code == "first order" && FirstOrder) {
							product.first_order = true;
						}
						if (product.is_lrpt_product != 0 && notsku[sku]) {
							product.control = 20;
							result=true;
						} else {
							let is_inventory = product.is_inventory;
							if (
								is_inventory == 1 ||
								(is_inventory == 10 &&
									this.default_store_id == "501")
							) {
								//庫存商品才校驗庫存
								//let stock = product.stock;
								//"warehouse":"501",
								//let control = this.productStock.control;      //0:無庫存，不能看到，1:無庫存，不能銷售，但能看到
								product.control = -1; //未查詢到庫存信息
								product.stock = 0;
								this.productStock.forEach(
									(warehouse, index1) => {
										if (
											this.default_store_id ==
											warehouse.warehouse
										) {
											warehouse.stock.forEach(
												(stock, index2) => {
													let control = stock.control;
													if (stock.sku == sku) {
														result = true;
														if (stock.stock <= 0) {
															product.control = control;
														} else {
															product.control = 2; //有庫存，可以銷售
														}
														product.stock =
															stock.stock;
													}
												}
											);
										}
									}
								);
							} else if (is_inventory == 10) {
								product.control = -1;
							} else {
								product.control = 10; //不判斷庫存，任意銷售
								product.stock = 999999999;
							}
						}

						productList[i2] = product;
					});
					if (result) {
						newProductInfo.push(item);
					}
					//lists[i1] = item;
				});
				return newProductInfo;
			} else {
				return [...((this.productInfo || {}).value || [])];
			}

			//return this.productInfo.value;
		},
		pageProducts() {
			var page = this.PageIndex;
			var arry = this.showProducts.slice(
				(page - 1) * this.pageCount,
				page * this.pageCount
			);
			return arry;
		},
		showProducts() {
			let result = [];
			if (!this.productInfo || !this.menuList) {
				return [];
			}
			let menuList = this.searchList || this.menuList;
			console.log(menuList)
			if (this.menuIndex != -1) {
				result =
					menuList &&
					menuList
						.filter((item, index) => this.menuIndex == index)
						.map(item => item.products);
			} else {
				result = menuList && menuList.map(item => item.products);
			}
			var products = Array.prototype.concat.apply([], result);
			if (this.menuIndex == -1) {
				const res = new Map();
				products = products.filter(
					a => !res.has(a.sku) && res.set(a.sku, 1)
				);
			}

			products = products.filter(item => this.isShowProduct(item));
			if(this.sales_sort){
				products = products.sort((a, b) => {
					let priceA = a
						? this.isPVOriginalPrice
							? a.sales
							: a.sales
						: 0;
					let priceB = b
						? this.isPVOriginalPrice
							? b.sales
							: b.sales
						: 0;
					(priceA = parseFloat(priceA)),
						(priceB = parseFloat(priceB));
					return this.sales_sort == "asc"
						? priceA - priceB
						: priceB - priceA;
				});
			}
			if (this.price_sort) {
				products = products.sort((a, b) => {
					let priceA = a.specproducts[0]
						? this.isPVOriginalPrice
							? a.specproducts[0].original_price
							: a.specproducts[0].price
						: 0;
					let priceB = b.specproducts[0]
						? this.isPVOriginalPrice
							? b.specproducts[0].original_price
							: b.specproducts[0].price
						: 0;
					(priceA = parseFloat(priceA)),
						(priceB = parseFloat(priceB));
					return this.price_sort == "asc"
						? priceA - priceB
						: priceB - priceA;
				});
			}
			if (this.pv_sort) {
				products = products.sort((a, b) => {
					let priceA = a.specproducts[0]
						? this.isPVOriginalPrice
							? a.specproducts[0].pv
							: a.specproducts[0].pv
						: 0;
					let priceB = b.specproducts[0]
						? this.isPVOriginalPrice
							? b.specproducts[0].pv
							: b.specproducts[0].pv
						: 0;
					(priceA = parseFloat(priceA)),
						(priceB = parseFloat(priceB));
					return this.pv_sort == "asc"
						? priceA - priceB
						: priceB - priceA;
				});
			}
			return products;
		},
		productCount() {
			return this.showProducts && this.showProducts.length;
		}
	},
	methods: {
		...mapActions([
			"initNoticeAction",
			"initWarehouseAction",
			"initProductStock",
			"initProductAction",
			"initProductLimtAction",
			"selectWarehouseAction",
			"initPromoteAction",
			"WxcheckCodeAction",
			"checkBirthdaySuitAction",
			"getTipDetailAction",
			"saveStoreIdAction",
			"getWechatUserInfoAction",
			"saveCartAction",
			"initCartAction",
			"getMenuItemsAction"
		]),
		...mapMutations([
			"SET_ISBUY",
			"SET_ORDERTYPE",
			"SET_BIRTHDAYLIMT",
			"CHOOSE_ADDRESS",
			"SET_CART_TOTAL",
			"SET_ORDERNN",
			"SET_CART_TOTALRPT"
		]),
		async switchLrp() {
			// if (this.switchOrder) {
			// 	var res = await this.getTipDetailAction("createLRP");
			// 	console.log(res)
			// 	if (res) {
			// 		this.lrpContent = res.Content;
			// 		this.lrpShow = true;
			// 	}
			// 	return;
			// }
			this.initData();
		},
		lrpConfirm() {
			location = `${cvoUrl}/vo/index.html#/mine/choosePeriod?token=${this.getAccessToken}&source=WebSite`;
		},
		lrpCancel() {
			if (this.lrpStatus) {
				this.lrpShow = false;
				this.initData();
			} else {
				this.lrpStatus = true;
			}
		},
		checkPermission(roleCode) {
			roleCode = roleCode?.toLowerCase();
			if (!roleCode) return true;

			if (roleCode == "lrp2" || roleCode == "lrp1") {
				return this.newcustomer;
			}
			let userlevel = this.userlevel.toLowerCase();
			if (roleCode.indexOf(userlevel) != -1) return true;
			return false;
		},
		async initCart() {
			await this.initCartAction();
		},
		async initData() {
			console.log(this.cartInfo)
			//計算
			if (this.newcustomer) {
				this.SET_ORDERTYPE(11);
			} else {
				this.SET_ORDERTYPE(0);
			}

			// let response = await this.getMenuItemsAction();
			// let topMenus = [],
			// 	bottomMenus = [];
			// var Datas = (response || {}).Datas || [];
			// Datas.forEach(item => {
			// 	if (item.MenuFlag == 10 || item.MenuFlag == 11) {
			// 		topMenus.push(item);
			// 	}
			// });
			// if (topMenus[0]) {
			// 	var menuArry = topMenus.filter(u => u.Code == "WSFT_Product");
			// 	this.topMenus = menuArry[0] && menuArry[0].Childs;
			// }

			this.notices = await this.initNoticeAction();
			console.log(this.notices)
			await this.initWarehouseAction();
			if (this.$route.query.preaction == "1") {
			} else {
			}
			await this.initProductStock(this.default_store_id);
			await this.initProductAction();

			await this.initPromoteAction(true);
			await this.initProductLimtAction();

			this.setOtherCar();

			//計算生日套裝
			// await this.checkBirthdaySuit();
			// if (this.isFirstOrder) {
			// 	var code;
			// 	this.menuList.forEach((item, index) => {
			// 		code = item.code && item.code.toLowerCase();
			// 		if (code == "first order") {
			// 			this.chooseMenu(index);
			// 		}
			// 	});
			// 	this.auto = true;
			// } else if (this.menuType) {
			// 	this.selectType();
			// }
		},
		selectType() {
			this.menuList.forEach((item, index) => {
				if (item.code == this.menuType) {
					this.chooseMenu(index);
				}
			});
			this.auto = true;
		},
		async checkBirthdaySuit() {
			this.SET_BIRTHDAYLIMT(-1);
			if (!this.getUserId) return;

			var birthday = this.userInfo.value.binding.register.birthday;
			// var now_time = this.systemDetail.now_time;
			var now_time = new Date();
			if (isNaN(birthday)) {
				var arr = birthday.split(/[- : \/]/);
				var birthday_date = new Date(
					arr[0],
					arr[1] - 1,
					arr[2],
					arr[3],
					arr[4],
					arr[5]
				);
				var arr1 = now_time.split(/[- : \/]/);
				var now_time_date = new Date(
					arr1[0],
					arr1[1] - 1,
					arr1[2],
					arr1[3],
					arr1[4],
					arr1[5]
				);
				if (birthday_date.getMonth() == now_time_date.getMonth()) {
					var res = await this.checkBirthdaySuitAction(
						this.userInfo.value.binding.user_id
					);
					if (res) {
						if (res.v == 1) {
							this.SET_BIRTHDAYLIMT(1);
						} else {
							this.SET_BIRTHDAYLIMT(0);
						}
					}
				}
			}
		},
		setOtherCar() {
			this.setCartTotal(this.baseDeliveryFee, this.baseServiceFee, 0);
		},
		pageChange(index) {
			this.PageIndex = index;
		},
		select(string) {
			this.$router.push(string);
		},
		formatNoticeDate(date) {
			if (date && date != "") {
				return util.formatDate.format(date);
			}
			return "";
		},
		chooseMenu(index) {
			this.menuIndex = index;
			this.menuIndexChange = false;
			this.PageIndex=1;
			//this.auto=false;
		},
		searchTarget(historyValue) {
			this.searchList = null;
			var sear = [];
			var productsList = [];
			var productsItem = [];
			var result = false;
			var searload = [];
			let searchValue =
				(historyValue||this.searchValue).toLowerCase();
			this.menuList.forEach((item, index, fe) => {
				productsItem = [];
				productsList = [];
				if (item.products.length > 0) {
					item.products.forEach((item1, index1, fe1) => {
						var name = item1.name.toLowerCase();
						var sku = item1.sku.toLowerCase();

						if (
							name.indexOf(searchValue) >= 0 ||
							sku.indexOf(searchValue) >= 0
						) {
							productsItem.push(item1);
							result = true;
						}
					});
					if (result) {
						if (productsItem.length > 0) {
							productsList = Object.assign({}, item);
							searload.push(index);
							productsList.products = productsItem;
							sear.push(productsList);
						}
					}
				}

				result = false;
			});
			if (sear.length > 0) {
				this.PageIndex = 1;
				this.chooseMenu(-1);
				this.searchList = sear;
			} else {
				this.PageIndex = 1;
				this.chooseMenu(-1);
				this.searchList = null;
			}
		},
		noStock(product) {
			return (
				!(product.specproducts && product.specproducts.length > 0) ||
				!(product.control == 2 || product.control == 10)
			);
		},
		noStockText(product) {
			//coming soon
			if (product.control == 20) {
				return "僅LRP用戶";
			}
			if (product.is_inventory == 10 && this.default_store_id != "501") {
				return "僅快遞(Only Delivery)";
			} else if (
				product.online_myo_begin &&
				product.online_myo_begin != "" &&
				this.nowDate <
					util.formatDate.dateFromStr(product.online_myo_begin)
			) {
				return "敬請期待(Coming Soon)";
			} else if (this.noStock(product)) {
				if (product.product_flag == 1) {
					return "售罄(Sold Out)";
				}
				return "暫售完(Out of Stock)";
			}
			return null; //正常銷售
		},
		productFilter(type) {
			//this.menuIndex=-1;
			this.PageIndex=1;
			switch (type) {
				case 'sales':
					this.show_onlyNew = false;
					this.show_onlyPromotion = false;
					this.show_onlyHot = false;
					this.pv_sort = null;
					this.price_sort = null;
					if(this.sales_sort=='asc'){
						this.sales_sort=null
					}
					else{
						this.sales_sort =
						this.sales_sort == "desc" ? "asc" : "desc";
					}
					break;
				case "sort":
					this.show_onlyNew = false;
					this.show_onlyPromotion = false;
					this.show_onlyHot = false;
					this.pv_sort = null;
					this.sales_sort=null;
					if(this.price_sort=='asc'){
						this.price_sort=null
					}
					else{
						this.price_sort =
						this.price_sort == "desc" ? "asc" : "desc";
					}
					
					break;
				case "pvsort":
					this.show_onlyNew = false;
					this.show_onlyPromotion = false;
					this.show_onlyHot = false;
					this.price_sort = null;
					this.sales_sort=null;
					if(this.pv_sort=='asc'){
						this.pv_sort=null
					}
					else{
						this.pv_sort = this.pv_sort == "desc" ? "asc" : "desc";
					}
					
					break;
				case "new":
					this.price_sort = null;
					this.pv_sort = null;
					this.sales_sort=null;
					this.show_onlyPromotion = false;
					this.show_onlyHot = false;
					this.show_onlyNew = !this.show_onlyNew;
					break;
				case "promotion":
					this.price_sort = null;
					this.pv_sort = null;
					this.sales_sort=null;
					this.show_onlyNew = false;
					this.show_onlyHot = false;
					this.show_onlyPromotion = !this.show_onlyPromotion;
					break;
				case "hot":
					this.price_sort = null;
					this.pv_sort = null;
					this.sales_sort=null;
					this.show_onlyNew = false;
					this.show_onlyPromotion = false;
					this.show_onlyHot = !this.show_onlyHot;
					break;
				default:
					break;
			}
		},

		confirm1() {
			return new Promise((resolve, reject) => {
				this.$Modal.info({
					title: "升級提示",
					content:
						"您的本次訂購已經達到100PV，請完善您的個人資料成為優惠顧客，並且可以立即以優惠顧客價格支付本次訂單。<br>Your order has reached 100PV,please fill in your personal information to become preferred customer, and you can pay for this order at preferred customer price immediately.",
					okText: "是(Yes)",
					onOk: () => {
						location = `${cvoUrl}/vo/index.html#/enroll/appendPcInfo?token=${this.getAccessToken}&source=WebSite`;
						//resolve(true)
					}
					// onCancel:()=>{
					// 	resolve(false)
					// }
				});
			});
		},
		async confrimfirst() {
			if (this.firstLoad) {
				return;
			}
			let pvResult = false;

			this.firstLoad = true;
			this.$Spin.show({
				render: h => {
					return h("div", [
						h("Icon", {
							class: "demo-spin-icon-load",
							props: {
								type: "load-c",
								size: 18
							}
						}),
						h("div", "正在立即結算請稍等...")
					]);
				}
			});
			this.loadpromoteList();
			let ret = await this.saveStoreIdAction(this.default_store);
			if (ret) {
				this.$Modal.error({
					title: "錯誤 (error)",
					content: ret
				});
				this.firstLoad = false;
				this.$Spin.hide();
				return false;
			}
			var initAddress = this.userInfo.value.binding.address || [];
			var zc = initAddress.filter(u => u.address_type == "0");
			if (zc[0]) {
				this.CHOOSE_ADDRESS({
					address: zc[0],
					index: 0
				});
			} else {
				this.CHOOSE_ADDRESS({
					address: null,
					index: 0
				});
			}
			if (this.choosedAddress && this.choosedAddress.id) {
				this.setCartTotal1(
					this.baseDeliveryFee,
					this.baseServiceFee,
					0,
					pvResult
				);
				let cx = this.CxList();

				let ll = this.shopCartList();

				ll = this.setCarImg(ll);

				ll = [...ll, ...cx];
				var type = this.Ispromote(ll);
				var for_vipno = this.userInfo.value.binding.register.vip_no;
				var catalog = this.userInfo.value.binding.catalog;
				var first_order_status = this.userInfo.value.binding
					.first_order_status;
				let cv = this.cartInfo.value;

				let minCart = {
					id: cv.id,
					is_result: type,
					catalog: catalog,
					vip_no: for_vipno,
					first_order_status: first_order_status,

					customer_id: this.userInfo.value.binding.user_id,
					store_id: this.default_store_id,
					address_id: this.choosedAddress.id,

					total_num: cv.num,
					total_price: cv.total_price,
					total_pv: cv.total_pv,
					total_change_point: cv.total_change_point,
					total_change_point_num: cv.total_change_point_num,
					total_product_amount: cv.total_product_amount,
					delivery_fee: cv.delivery_fee,
					service_fee: cv.service_fee,
					ar_value: cv.ar_value,
					pay_fee: cv.pay_fee,
					spec_code: this.promote_code,
					lrpt_order: 0,
					is_confirm: 1,
					detail: ll
				};
				let res = await this.saveCartAction({ minCart, type: true });
				this.$Spin.hide();
				if (res && res.response && res.response.code == "1") {
					if (res.data.value.code == 1) {
						if (this.newcustomer) {
							this.SET_ORDERTYPE(11);
						} else {
							this.SET_ORDERTYPE(0);
						}
						this.SET_ORDERNN(null);

						if (
							this.isOriginalPrice &&
							(!this.selfCarNo ||
								(this.payPv < 100 && this.selfCarNo))
						) {
							this.newValue = true;
							this.firstLoad = false;
							return;
						}
						this.$router.push({
							path: "/order/confirm"
						});
					} else if (ret.response.errorCode == "0100") {
						this.$Modal.error({
							title: "錯誤 (error)",
							content: ret.data.value.message,
							loading: true,
							okText: "重新加載",
							onOk: async () => {
								await this.getWechatUserInfoAction();
								this.$Modal.remove();
							}
						});
					} else {
						this.$Modal.error({
							title: "錯誤 (error)",
							content: ret.data.value.message
						});
					}
				} else {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: "立即結束失敗"
					});
				}
			} else {
				this.$Modal.error({
					title: "錯誤 (error)",
					content: "地址信息不正確"
				});
				this.$Spin.hide();
			}

			this.firstLoad = false;
		},
		Ispromote(ll) {
			//檢測此單是否存在促銷
			if (this.promote_code) {
				return 1;
			}
			var is = ll.filter(u => u.product_flag == 1);
			if (is[0]) {
				return 1;
			}

			return 0;
		},
		setCarImg(list) {
			list.forEach((item, index) => {
				if (item.product_flag != 1) {
					var obj = this.menuList.filter(u => u.sku == item.sku);
					if (obj[0]) {
						item.Url = obj[0].image_path_big;
						item.specification = obj[0].specification;
					}
				}
			});
			return list;
		},
		setCartTotal(delivery_fee, service_fee, ar_value) {
			this.SET_CART_TOTALRPT({ delivery_fee, service_fee, ar_value });
		},
		setCartTotal1(delivery_fee, service_fee, ar_value, pvResult) {
			var result = this.isPVOriginalPrice;
			if (pvResult) {
				result = true;
			}
			this.SET_CART_TOTAL({
				delivery_fee,
				service_fee,
				ar_value,
				result
			});
		},
		shopCartList() {
			let newArr = new Array();
			this.shopCart.forEach(item => {
				if (item.num > 0) {
					var product_flag = item.is_lrpt_product || 0;
					if (item.is_hot == "1" && this.orderType != 0) {
						product_flag = 100;
					}
					newArr.push({
						attrs: [],
						extra: {},
						id: item.id,
						name: item.name,
						packing_fee: item.packing_fee,
						price: item.price,
						pt: item.pt,
						pv: item.pv,
						point: item.point,
						amount: item.amount, //現金支付金額
						ar_value: 0, //AR支付金額
						num: item.num, //數量(個數)，point支付和 amount支付總計個數
						sku_id: item.sku_id,
						sku: item.sku,
						specs: item.specs,
						stock: item.stock,
						selected: item.selected,
						spec_code: null,
						product_flag: product_flag,
						promo_code: item.promo_code,
						Url: null
					});
				}
			});
			return newArr;
		},
		isShowProduct(product) {
			let show = product.control > 0;
			if (show && this.show_onlystock) {
				show = !this.noStock(product);
			}
			if (show && this.show_onlyNew) {
				show = product.is_new == 1;
			}
			if (show && this.show_onlyPromotion) {
				show = product.is_promotion == 1;
			}
			if (show && this.show_onlyHot) {
				show = product.is_hot == 1;
			}
			let priceBegin = parseFloat(this.priceBegin);
			let priceEnd = parseFloat(this.priceEnd);

			let price = product.specproducts[0]
				? this.isOriginalPrice
					? product.specproducts[0].original_price
					: product.specproducts[0].price
				: 0;
			if (show && priceBegin) {
				show = price >= priceBegin;
			}
			if (show && priceEnd) {
				show = price <= priceEnd;
			}
			return show;
		},
		filterPrice() {
			this.priceBegin = this.t_priceBegin;
			this.priceEnd = this.t_priceEnd;
		},
		clearPriceFilter() {
			this.priceBegin = this.t_priceBegin = null;
			this.priceEnd = this.t_priceEnd = null;
		},
		async selectStore(item) {
			this.warehouseOpen = false;
			if (this.default_store_id != item.Code) {
				// this.default_store_id = item.Code;
				// this.default_store = item;
				this.showLoading = true;
				await this.initProductStock(item.Code);
				var ddm = "0";
				var ddmd = "門店自提";
				if (item.Code == "501") {
					//送貨上門
					ddm = "1";
					ddmd = "送貨上門";
				}
				this.selectWarehouseAction({
					default_delivery_mode: ddm,
					default_delivery_mode_desc: ddmd,
					default_store_id: item.Code,
					default_store_name: item.Name,
					default_store_nameen: item.NameEn
				});
				this.hideLoading();
				//this.productLoad=false;
			}
		},
		hideLoading() {
			// clearTimeout(this.timer);
			// this.timer = setTimeout(() => {
			//     clearTimeout(this.timer);
			this.showLoading = false;
			//  }, 600)
		},
		showPromoCode(products) {
			if (products) {
				this.PromoModel = products;
			}
			this.PromoModelShow = !this.PromoModelShow;
		},
		showSurveyfun(model){
			if (model) {
				this.survey = model;
			}
			
			this.showSurvey = !this.showSurvey;
		},
		showTips() {},
		handleScroll(scrollTop) {
			this.scrollTop = scrollTop;
		},
		close() {
			this.newValue = false;
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.lrpCancel {
	display: inline-block;
	margin-right: 10px;
}
.lrpConfirm {
	padding-top: 10px;
	padding-bottom: 10px;
	text-align: center;
	//color: #bc86c8;
	font-weight: 800;
}
.orderPage {
	//position: relative;
	// width: 78.03vw;
	// margin: 40px auto;
	//text-align: left;
	//@include fontSize($font-size-14);
	.resultwrap {
		// margin-top: 0.5rem;
	}
	.options {
		width: 78.03vw;
		margin: 0 auto;
	}
	.opertaion {
		margin-bottom: 0.05rem;
		background-color: #fff;
		border: 1px solid #eaeaea;
		overflow: hidden;
	}
}
.m-brand2 {
	position: relative;
	height: calc(40vw / 2);
	margin: 20px 0 10px;
	overflow: hidden;
	background-color: #fff;
	.content-left {
		position: relative;
		width: 40vw;
		float: left;
		.demo-carousel {
			height: 350px;
			height: calc(40vw / 2);
			position: relative;
			img {
				width: 100%;
			}
		}
		.detailImg {
			cursor: pointer;
			display: block; // background: url(/VO/static/img/doterra_building.jpg) no-repeat 0 0;
			background-position: center center;
			background-repeat: no-repeat; // background-size: cover;
			height: 100%;
			//background-size:100% 100%;
		}
	}
	.content {
		margin-left: 40vw;
		// width: 510px;
		padding: 20px;
	}
	.info {
		height: 70px;
	}
	.logo-div {
		// background-image: url("../../../assets/order/logo.png");
		position: relative;
		background-size: cover;
		width: 68px;
		height: 68px;
		float: left; //border: 1px solid #eaeaea;
	}
	.intro {
		margin-top: 10px;
		@include fontSize($font-size-15);
		line-height: 24px;
		word-wrap: break-word;
		word-break: break-all;
		.title {
			margin-bottom: 5px;
		}
		a {
			position: absolute;
			bottom: 10px;
			right: 50px;
			@include fontSize($font-size-14);
			color: $theme-color;
			span {
				position: relative;
				top: -1px;
			}
		}
	}
	.logo {
		display: block;
		width: 69px;
		height: 100%;
		position: absolute;
		left: -1px;
		border: 1px solid #eaeaea;
	}
	.bname {
		float: left;
		margin-left: 12px;
		height: 70px;
		width: 75%;
		overflow: hidden;
		.sub-title {
			color: #999;
			text-align: left;
			@include fontSize($font-size-14);
		}
	}
	.title {
		margin-top: 10px;
		@include fontSize($font-size-20);
		line-height: 28px;
		font-weight: bold;
	}
	.detailshort {
		@include fontSize($font-size-14);
		line-height: $font-size-25;
		// line-height: 20px;
		overflow: hidden;
		zoom: 1; //font-weight: 400;
		&.f-ellip5 {
			overflow: hidden;
			//max-height: 100px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 5;
			text-overflow: ellipsis;
			white-space: normal;
		}
	}
}
.resultinfo {
	margin: 15px 0 10px;
	line-height: 22px;
	margin-top: 0;
	.detail-search {
		position: relative;
		@include fontSize($font-size-12);
		margin-right: 10px;
	}
	.gnum {
		height: 22px;
		display: inline-block;
		line-height: 24px;
		color: #999;
		@include fontSize($font-size-14);
		i {
			color: #e31436;
			font-style: normal;
			font-weight: 500;
		}
		b {
			font-weight: 500;
		}
	}
}

.opertaion {
	margin-bottom: 10px;
	background-color: #fff;
	border: 1px solid #eaeaea;
	overflow: hidden;
}
.m-filter {
	background-color: #fff;
	.hdorder {
		//height: 36px;
		background-color: #fff;
	}
	
	.order dd {
		float: left;
		height: 0.44rem;

		line-height: 0.44rem;
		//margin: -0.03rem;
		margin-left: 0;
		@include fontSize($font-size-14);
		color: #333;
		border: 1px solid #eaeaea;
		border-bottom: none;
		border-top: none;
		cursor: pointer;
		text-align: center;
		border-left: 0;
		&:first-child {
			border-left: none;
		}
		
		span {
			width: 100%;
			height: 100%;
			display: block;
			margin: 0px 0.03rem;
				padding-right: 10px;
			b {
				@include fontSize($font-size-14);
				font-weight: 500;
				margin: 0rem 0.04rem;
			}
			&.price_sort_span{
				padding-right: 0.2rem;
			}
			&.pv_sort_span{
				padding-right: 0.2rem;
			}
		}
		.price_sort {
			display: inline-block;
		//	width: 7px;
			height: 0.44rem;
			line-height: 0.44rem;
			vertical-align: top;
			position: absolute;
		//	top: -3px;
			//right: 0.18rem;
		}
		.sort-icon {
			display: inline-block;
			height: 0.1rem;
			position: absolute;
			color: #333;
			@include fontSize($font-size-17);
			&.sort_active {
				color: $theme-color;
			}
			&.asc {
				top: 0.09rem;
			}
			&.desc {
				bottom: 0.12rem;
			}
		}
		span:last-child {
		
			position: relative;
		}
		&.active {
			position: relative;
			border: 1px solid $theme-color;
			color: #bc86c8;
			@include fontSize($font-size-14);
			margin: 0;
		}
	}
	.simplePage {
		float: right;
		margin-right: 15px;
		margin-top: 12px;
		line-height: 12px;
		i {
			color: #e31436;
			font-style: normal;
			font-weight: 500;
		}
		span {
			display: inline-block;
			float: left;
			margin-left: 15px;
			background: url(../../../assets/order/icon-new.png) -9999px -9999px
				no-repeat;
			&.def-left {
				background-position: 0px -188px;
				cursor: default;
			}
			&.def-right {
				background-position: 0px -209px;
				cursor: default;
			}
		}
		.arrow-left {
			background-position: -20px -188px;
			width: 8px;
			height: 13px;
			cursor: pointer;
		}
		.arrow-right {
			background-position: -21px -210px;
			width: 8px;
			height: 13px;
			cursor: pointer;
			display: inline-block;
			float: left;
			margin-left: 15px;
		}
	}
	.m-priceBox {
		display: none;
		position: relative;
		z-index: 2;
		float: left;
		width: 124px;
		height: 36px;
		line-height: 36px;
		@include fontSize($font-size-14);
		.priceInputs {
			position: absolute;
			left: 8px;
			top: -1px;
			padding: 0 8px;
			&:hover {
				left: 7px;
				top: -2px;
				border: 1px solid #eaeaea;
				height: 68px;
				background-color: #fff;
				box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
				.clearbtn,
				.btnconfirm {
					display: block;
				}
			}
			input {
				width: 34px;
				line-height: 18px;
				padding-left: 4px;
				border: 1px solid #ddd;
				font-size: 100%;
				vertical-align: middle;
				display: inline-block;
				outline: none;
				&:hover {
					border: 1px solid $theme-color;
					box-shadow: 0 0 6px 1px $theme-color;
					-webkit-box-shadow: 0 0 6px 1px $theme-color;
				}
			}
		}
		label {
			cursor: default;
		}
		.clearbtn {
			display: none;
			position: absolute;
			right: auto;
			left: 15px;
			top: 42px;
			line-height: 16px;
			@include fontSize($font-size-12);
			color: #51b8f1;
			cursor: pointer;
		}
		.btnconfirm {
			display: none;
			position: absolute;
			top: 40px;
			right: 10px;
			line-height: 16px;
			margin-left: 5px;
			padding: 2px 8px;
			border-radius: 3px;
			color: #fff;
			background: #e31436;
			border: 0;
			cursor: pointer;
			@include fontSize($font-size-12);
		}
	}
	.m-checkbox {
		margin-left: 10px;
		position: relative;
		float: left;
		margin-left: 15px;
		line-height: 0.44rem;
		@include fontSize($font-size-14);
		cursor: pointer;
	}
	.m-addrbox {
		margin-left: 20px;
		float: left;
		height: 0.44rem;

		.tit {
			float: left;
			height: 0.44rem;
			line-height: 0.44rem;
			@include fontSize($font-size-14);
		}
		.addrselect {
			@include fontSize($font-size-14);
			float: left;
			margin: 0.09rem 0 0 10px;
			button {
				//padding: 2px 4px;
			}
		}
	}
}
.z-cat3 {
	//border-bottom: 1px dotted #eaeaea;
}
.m-classify {
	position: relative;
	background: #f8f8f8;
	.name {
		@include fontSize($font-size-14);
		//line-height: 12px;
		padding-top: 12px;
		width: 1rem;
		white-space: nowrap;
		text-overflow: ellipsis;
		//overflow: hidden;
		float: left;

		color: #666;
		text-align: center;

		background: #f8f8f8;
	}
	.icon-tridown {
		display: inline-block;

		@include fontSize($font-size-14);
		color: #cbcbcb;
	}
	.hdbrands {
		margin-left: 1rem;
		padding: 8px 120px 4px 0;
		background-color: #fff;
	}
	.hdbrands2 {
		position: relative;
		overflow: hidden;
		height: 0.3rem;
		&.auto {
			height: auto;
		}
	}
	.brands {
		float: left;
		margin-left: 15px;
		//line-height: 14px;
		overflow: auto;
		.activity_menu {
			color: #bc86c8;
		}
		a {
			float: left;
			display: inline-block;
			cursor: pointer;
			text-decoration: none;
			color: #333;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;

			position: relative;
			box-sizing: border-box;
			margin-right: 18px;
			margin-bottom: 4px;
			padding: 3px 5px;
			//width: 120px;
			border: 1px solid transparent;
			@include fontSize($font-size-14);
			//line-height: 12px;
		}
	}
	.morewrap {
		position: absolute;
		top: 12px;
		right: 0;
	}
	.more {
		position: relative;
		float: right;
		//width: 42px;
		margin: auto 15px;
		//	line-height: 13px;
		@include fontSize($font-size-14);
		cursor: pointer;
		margin-left: 0;
		span {
			background-position: 0 0;
			position: absolute;
			width: 9px;
			height: 6px;
			background: url(../../../assets/order/icon-new.png) -9999px -9999px
				no-repeat;
		}
	}
}
.m-result {
	overflow: hidden;
	padding-bottom: 50px;
	margin-bottom: 6px;
	ul {
		list-style: none;
	}
}
.pageRegion {
	margin-bottom: 20px;
	text-align: right;
	.customize {
		.ivu-page-prev,
		.ivu-page-next {
			border: none;
		}
	}
}

.indicator {
	position: absolute;
	bottom: 2.08vw;
	display: flex;
	width: 100%;
	justify-content: center;
	.dots {
		display: flex;
		//background-color: #B4BBBF;
		border-radius: 20px;
		height: 20px;
		.dot {
			cursor: pointer;
			width: 13px;
			margin: 5px;
			height: 13px;
			// border: 2px solid white;
			background-color: #3333336b;
			border-radius: 10px;
		}
		.active {
			background-color: #090909;
		}
	}
}
@media (max-width: 1280px){
	.m-brand2 .detailshort.f-ellip5{
		-webkit-line-clamp: 3;
	}
}
//移動版樣式
@media (max-width: 768px){
		.indicator{
			.dots{
				.dot{
					width: .4rem;
					height: .4rem;
				}
			}
		}
		.m-result{
			padding-top: 5px;
		}
		.orderPage{
			.options{
				width: 100%;
   				margin: 0 auto;
			}
			.m-classify{
				display: none;
			}
			.opertaion{
				border: none;
				margin: 0px;
				margin-top: 5px;
				padding-bottom: 5px;
				border-bottom: 1px solid #eaeaea;
			}
			// .opertaion{
			// 	display: none;
			// }			
		}
		.m-filter{
			padding: 0 5px;
			.order{
				//padding: 0 5px;
				dd{
					padding: 0 0.5rem;
					font-size: 0.48rem;
					height: auto;
					border-bottom: 1px solid #eaeaea;
					border-top: 1px solid #eaeaea;
					line-height:inherit;
					&:first-child{
						border: 1px solid #eaeaea;
						&.active{
							font-size: 0.48rem;
							border: 1px solid #B176C5;
						}
						
					}
					&:last-child{
						//border-left:1px solid #eaeaea;
						//margin-top: 5px;
						&.active{
							font-size: 0.48rem;
							border: 1px solid #B176C5;
						}
					}
					&.active{
						font-size: 0.48rem;
					}
					span{
						//height: 31px;
						//line-height: 30px;
						b{
							display: block;
							margin: 0;
						}
						&.pv_sort_span{
							padding: 0px;
						}
						&>div{
							right: 0px;
							top: 5px;
						}
					}
					.sort-icon{
						font-size: 0.52rem;
						height:0.0rem;
					}
				}
			}
		
				
				.m-addrbox{
					margin-left: 0px;
					height: 32px;
					line-height: 32px;
					.addrselect{
						margin: 0px;
						margin-top: 5px;
						padding-left: 10px;
						//margin: 0.19rem 0 0 10px;
						font-size: inherit;
					}
    				//font-size: 0.55rem;
					
					.tit{
						display: none;
					}
				}
				.m-checkbox{
					height: 32px;
					line-height: 34px;
					display: inline-block;
					margin-left: 5px;
					margin-top: 5px;
				
				}
			
			
		}
		.m-brand2{
			height: calc(100vw / 2);
			margin: 0;
			height: auto;
			padding-bottom: 10px;
			margin-bottom: 15px;
			overflow: inherit;
			.content-left {
				float: inherit;
				.demo-carousel {
					height: calc(100vw / 2);
					img{
						width: 100%;
					}
				}
				width: 100%;
			}
			.content{
				margin-left:0;
				padding: 5px;
			}
			.bname{
				width: inherit;
				.title{
					font-size: 0.69rem;
					line-height: inherit;
				}
				.sub-title{
					font-size: 0.58rem;
				}
			}
			.detailshort.f-ellip5{
				-webkit-line-clamp: 3;
			}
			.detailshort{
				line-height: 1.01rem;
				font-size: 0.48rem;
			}
			.intro{
				line-height: inherit;
				.title{
					font-size: 0.69rem;
					line-height: inherit;
				}
				a{
					bottom:-10px;
					right: 0;
				}
			}
			
		}
		.resultinfo{
			display: none;
		}
		.m-filter{
		.hdorder{
			    background-color: #fff;
    			position: relative;
				/* width: 99999px; */
				height: 45px;
				overflow: scroll;
				&::-webkit-scrollbar{
					 display: none;
				}
		}
		
	}
	.m-filter .order dd.padding{padding: 0 0.7rem;}
	.order{
		width: 500px;
	}
	}
</style>